import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { Count, Trend, TrendColorScheme } from '../types.tsx';

export const getTrend = (currentCount: Count, wholePeriodCount: Count): Trend => {
	if (currentCount < wholePeriodCount) {
		return 'under';
	}

	if (currentCount > wholePeriodCount) {
		return 'over';
	}

	return 'equal';
};

export const getTrendIconBackgroundColor = (trend: Trend, colorScheme: TrendColorScheme) => {
	// RLSS-2812 replace color.icon.subtle into color.icon.accent.gray
	if (colorScheme === 'NEUTRAL' || trend === 'equal') {
		return token('color.icon.subtle', colors.N200);
	}
	if (
		(colorScheme === 'UP_IS_GOOD' && trend === 'over') ||
		(colorScheme === 'UP_IS_BAD' && trend === 'under')
	) {
		return token('color.icon.success', colors.G300);
	}
	if (
		(colorScheme === 'UP_IS_GOOD' && trend === 'under') ||
		(colorScheme === 'UP_IS_BAD' && trend === 'over')
	) {
		return token('color.icon.warning', colors.Y500);
	}
	// RLSS-2812 replace color.icon.subtle into color.icon.accent.gray
	return token('color.icon.subtle', colors.N200);
};
